import React from "react";
import { IconProps } from "..";

export default (props: IconProps) => (
    <svg {...props} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.185 10 6.81 18.333a3.887 3.887 0 0 1-.937-.582A5.765 5.765 0 0 1 5 16.844l6.932-6.824L5 3.34a8.14 8.14 0 0 1 .873-.955c.3-.277.612-.517.937-.718L15.185 10z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);
